export default __webpack_public_path__ + "static/media/TAANI_STORE._compressed.361b9323.png";